/**
 * Niche Configuration
 * This file is auto-generated based on the NICHE environment variable
 * Used to replace {{NICHE}} placeholders in locale files
 * 
 * Generated at: 2026-11-03T19:45:24.942Z
 */

// Niche value from environment variable (set at build time)
export const NICHE = 'latina'

export default NICHE
